import { render, staticRenderFns } from "./Function.vue?vue&type=template&id=47b5b94d"
import script from "./Function.vue?vue&type=script&lang=js"
export * from "./Function.vue?vue&type=script&lang=js"
import style0 from "./Function.vue?vue&type=style&index=0&id=47b5b94d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports